import { standardAccountNumberFormat } from "../../../../../utils/standardAccountNumberFormat";
import FormatAmount from "../../../FormatAmount/FormatAmount";
import TickerAnimation from "../../../TickerAnimation";
/**
 * @typedef {("AccountNumber" | "Amount" | "Text")} text1type
 * @typedef {("AccountNumber" | "Amount" | "Text")} text2type
 * @param {Object} props
 * @param {String} props.text1 - Header 1 text
 * @param {String} props.text2 -  Header 2 text
 * @param {String} props.subtext1 - Sub header 1 text
 * @param {String} props.subtext2 - Sub header 2 text
 * @param {text1type} props.text1type - Type of the header 1 text
 * @param {text2type} props.text2type - Type of the header 2 text
 * @returns {JSX.Element}
 */
const ListDualText = ({
  text1,
  text2,
  text1Color,
  text2Color,
  text1FontWeight,
  text2FontWeight,
  subtext1,
  subtext2,
  text1type,
  text2type,
  textCase,
}) => {
  const shouldBeRedacted = (price) => {
    return (
      price === "xxxx.xx" ||
      isNaN(+price) ||
      price === null ||
      price === undefined
    );
  };
  return (
    <div className="flex flex-row gap-x-gap-sm w-full min-w-0 px-padding-sm py-padding-sm relative">
      <div className="flex flex-col gap-y-gap-xs w-full  min-w-0">
        <p
          className="text-font-xs text-text-primary truncate block whitespace-nowrap overflow-hidden min-w-0 font-normal capitalize"
          style={{
            color: text1Color,
            fontWeight: text1FontWeight,
          }}
        >
          {text1type === "Amount" ? (
            <>
              {shouldBeRedacted(text1) ? "" : "INR"}{" "}
              <FormatAmount price={Number(text1)} />
            </>
          ) : text1type === "AccountNumber" ? (
            standardAccountNumberFormat(text1)
          ) : (
            <div className="truncate overflow-hidden whitespace-nowrap min-w-0">
              <TickerAnimation text={text1} />
            </div>
          )}
        </p>

        <p className="text-font-xxs text-text-secondary">{subtext1}</p>
      </div>

      <div className="border-l border-primary-bg"></div>

      <div className="flex flex-col gap-y-gap-xs w-full items-end  min-w-0">
        <p
          className="text-font-xs truncate text-text-primary block whitespace-nowrap overflow-hidden min-w-0 font-normal"
          style={{
            color: text2Color,
            fontWeight: text2FontWeight,
            textTransform: textCase ? textCase : "capitalize",
          }}
        >
          {text2type === "Amount" ? (
            <>
              INR <FormatAmount price={Number(text2)} />
            </>
          ) : text2type === "AccountNumber" ? (
            standardAccountNumberFormat(text2)
          ) : (
            <div className="truncate overflow-hidden whitespace-nowrap min-w-0">
              <TickerAnimation text={text2} />
            </div>
          )}
        </p>

        <p className="text-font-xxs text-text-secondary">{subtext2}</p>
      </div>
    </div>
  );
};

export default ListDualText;
